// Port of shelf_test/shelf/items_list.coffee calcItemsListProps — the "Shop Metrics" table.
// This one is exactly the nine shared metrics; the ecommerce question renders the same set
// plus its banner / Subscribe & Save sections.
//
// Note the price mask source differs from ecommerce: shelf test reads it off the shelf
// preview data, ecommerce off the model's priceTemplate.

import {
  buildShelfMetricsCols,
  buildShelfMetricsRows
} from '@aytm/app/stats/page/question-views/sh/lib/shelf-metrics-table'

export const calcShelfTableProps = ({ answer, viewMode, format, shelfPreviewData }) => {
  const isLoading = 'loading' === answer
  const values = isLoading || answer == undefined ? {} : answer

  const priceMask = shelfPreviewData?.price_mask || '{{price}}'
  const showPrice = !shelfPreviewData?.hide_price
  const hideTotal = true === format?.hideTotal

  return {
    cols: buildShelfMetricsCols({ values, viewMode, hideTotal }),
    rows: buildShelfMetricsRows({ values, isLoading, showPrice, priceMask })
  }
}
